import React from "react";
import { FormControlLabel, Switch } from "@mui/material";
import { usePlayerActions } from "../../actions";
import { SourceTopicSelect } from "../../components";
import type { TerminalPanel } from "../../panels";
import { usePairedTopics } from "../../panels";

export function TerminalVisualizationControls({
  panel,
}: {
  panel: TerminalPanel;
}) {
  const [pair] = usePairedTopics(panel);

  const playerActions = usePlayerActions();

  function handleToggleAutoScroll(): void {
    playerActions.toggleTerminalAutoScroll(panel);
  }

  return (
    <>
      <FormControlLabel
        sx={{
          justifyContent: "space-between",
          marginInlineStart: 0,
          marginBlockEnd: 2,
        }}
        control={
          <Switch
            checked={panel.autoScroll}
            onChange={handleToggleAutoScroll}
          />
        }
        label="Auto scroll"
        labelPlacement="start"
      />
      <SourceTopicSelect panel={panel} topic={pair.topic} />
    </>
  );
}
